import styled from 'styled-components';

//style
export const Content = styled.div`
    width: 100%;
    .row-flex {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
        gap: 0px;
        .text {
            color: #61788E;
            font-size: 16px;
            font-weight: 400;
            line-height: 32px;
            margin: -1px 0;
            @media (max-width: 600px) {
                font-size: 15px;
                line-height: 30px;
            }
        }
        .button {
            color: #80BAFF;
            cursor: pointer; 
            font-size: 15px;
            @media (max-width: 600px) {
                font-size: 14px;
            }
        }

    }
`;